import { Text } from "../../../../../../packages/ui-kit";
import { CircleLoader } from "../../../../../../packages/components";
import { FileIcon } from "./file-icon";
import { DownloadButton } from "./download-button";
import styles from "./file.module.scss";

type Props = {
  dataTestId?: string;
  name: string;
  shouldShownDownloadButton?: boolean;
  shouldShownLoader?: boolean;
  onClick?: () => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
};

const FileName = ({
  dataTestId,
  name,
  shouldShownDownloadButton,
  shouldShownLoader,
  onMouseEnter,
  onMouseLeave,
  onClick,
}: Props) => {
  const renderFileIcon = () => {
    if (shouldShownLoader) {
      return <CircleLoader type="medium" className={styles.icon} />;
    }

    if (shouldShownDownloadButton && onClick) {
      return <DownloadButton onClick={onClick} />;
    }

    return <FileIcon name={name} />;
  };

  return (
    <div
      className={styles["file-name-wrapper"]}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div className={styles["icon-wrapper"]}>{renderFileIcon()}</div>
      <Text size="xsmall" className={styles.name} dataTestId={dataTestId}>
        {name}
      </Text>
    </div>
  );
};

export { FileName };
